import { Link } from "expo-router";
import React from "react";
import { Text } from "~/components/Text";
import { View } from "~/components/View";
import { LanguagePicker } from "../intl/LanguagePicker";
import { useResponsive } from "../live-chat/useResponsive";

export function Footer() {
  const r = useResponsive();

  return (
    <View colorBackgroundDarkLight>
      <View
        flexDirectionRow
        alignItemsCenter
        justifyContentSpaceEvenly={r(true, false, false)}
        style={{
          gap: r(8, 32, 32),
          width: "100%",
          maxWidth: 1320,
          marginHorizontal: "auto",
        }}
        paddingHorizontalLarge={r(false, true, true)}
        paddingHorizontalExtraSmall={r(true, false, false)}
        paddingVerticalExtraSmall
      >
        <LanguagePicker />

        <Link href="https://bokbok.io/privacy-policy" target="_blank">
          <Text
            numberOfLines={1}
            colorLightSoft
            weightSemiBold
            sizeExtraSmall={r(true, false, false)}
            sizeMedium={r(false, true, true)}
          >
            {intl.formatMessage({
              defaultMessage: "Privacy Policy",
              id: "H8KCFi",
              description: "Footer link",
            })}
          </Text>
        </Link>
        <Link href="https://bokbok.io/terms-of-services" target="_blank">
          <Text
            numberOfLines={1}
            colorLightSoft
            weightSemiBold
            sizeExtraSmall={r(true, false, false)}
            sizeMedium={r(false, true, true)}
          >
            {intl.formatMessage({
              defaultMessage: "ToS",
              id: "H0Dk78",
              description: "Footer link",
            })}
          </Text>
        </Link>
        <Link href="https://bokbok.io/guidelines" target="_blank">
          <Text
            numberOfLines={1}
            colorLightSoft
            weightSemiBold
            sizeExtraSmall={r(true, false, false)}
            sizeMedium={r(false, true, true)}
          >
            {intl.formatMessage({
              defaultMessage: "Rules",
              id: "t1Pz6Q",
              description: "Footer link",
            })}
          </Text>
        </Link>
        {r(false, true, true) && (
          <>
            <View flex />
            <Text
              numberOfLines={1}
              colorLightSoft
              weightSemiBold
              sizeSmall={r(true, false, false)}
              sizeMedium={r(false, true, true)}
            >
              {intl.formatMessage(
                {
                  defaultMessage: "© {year} BokBok Live",
                  id: "UGSYk3",
                  description: "Footer text",
                },
                {
                  year: new Date().getFullYear().toString(),
                },
              )}
            </Text>
          </>
        )}
      </View>
    </View>
  );
}
